import { useState, useEffect } from "react";
import axios from "axios";
import Cardd from "./ClusterPOST/Card";
import CircularProgress from "@mui/material/CircularProgress";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
import { useNavigate } from "react-router-dom";
// import dotenv from "dotenv";
// dotenv.config();
function ClusterPost() {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const token = localStorage.getItem("TOKEN");
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);
  const [commentOpen, setCommentopen] = useState(false);
  const getClusterById = async () => {
    const clusterId = localStorage.getItem("clusterId");
    const url = baseUrl + `/api/cluster/getclusterbyname/${clusterId}`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    setPost(response.data.posts);
    setLoading(false);
  };

  useEffect(() => {
    getClusterById();
  }, []);

  return (
    <div className="flex flex-col-reverse gap-30 mb-10">
      <span style={{ textAlign: "center" }}>
        {loading && <CircularProgress color="success" />}
      </span>
      {post.length === 0 ? (
        <div className="w-full bg-white h-[400px] p-5 border pt-36 text-2xl text-center mb-5">
          All recent posts will be shown here
        </div>
      ) : (
        post.map((post) => {
          return (
            <Cardd
              width={width}
              post={post}
              baseUrl={baseUrl}
              token={token}
              commentOpen={commentOpen}
              setCommentopen={setCommentopen}
              navigate={navigate}
            />
          );
        })
      )}
    </div>
  );
}
export default ClusterPost;
